import React from 'react';
import EvaluationEpst from './EvaluationEpst';


const index = (props) => (
    <EvaluationEpst />
);

export default index;